var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.625H16.75V7.125C16.75 3.675 13.95 0.875 10.5 0.875C7.05 0.875 4.25 3.675 4.25 7.125V9.625H3C1.625 9.625 0.5 10.75 0.5 12.125V24.625C0.5 26 1.625 27.125 3 27.125H18C19.375 27.125 20.5 26 20.5 24.625V12.125C20.5 10.75 19.375 9.625 18 9.625ZM6.75 7.125C6.75 5.05 8.425 3.375 10.5 3.375C12.575 3.375 14.25 5.05 14.25 7.125V9.625H6.75V7.125ZM18 24.625H3V12.125H18V24.625ZM10.5 20.875C11.875 20.875 13 19.75 13 18.375C13 17 11.875 15.875 10.5 15.875C9.125 15.875 8 17 8 18.375C8 19.75 9.125 20.875 10.5 20.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.2fc41aabd7a49852bba4fc17dddc4c59.svg";
export { ForwardRef as ReactComponent };